import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.flexColumn,
  paddingBottom: 5,
}));

export const FlightTitle = styled("div")(({ theme, isOrange }) => ({
  paddingLeft: 20,
  height: 34,
  lineHeight: "34px",
  overflow: "hidden",
  color: isOrange ? theme.palette.error : theme.palette.primaryDark,
  backgroundColor: isOrange ? theme.palette.errorBg : theme.palette.primarySubtle,
  fontSize: 14,
}));

export const FlightsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
}));

export const InfoWrapper = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 10, 0),
  display: "flex",
  gap: 20,

  [theme.down("sm")]: {
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
}));

export const AirlineAndSitsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "center",
  gap: 5,
  width: 90,

  [theme.down("sm")]: {
    width: "auto",
  },
}));

export const SitsCount = styled("div")(({ theme }) => ({
  color: theme.palette.textSecondary,
  fontSize: 11,
}));

export const AirlineLogo = styled("img")(({ theme }) => ({
  width: 90,
  height: 30,
}));

export const FlightNumbersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "center",
  justifyContent: "center",
  gap: 5,
  width: 60,

  [theme.down("sm")]: {
    width: "auto",
  },
}));

export const FlightNumber = styled("div")(({ theme }) => ({
  color: theme.palette.textPrimary,
  fontSize: 13,
  lineHeight: 1,
}));

export const FlightTimingsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  justifyContent: "space-between",
  flexGrow: 1,
  gap: 30,

  [theme.down("sm")]: {
    width: "100%",
    gap: 20,
  },
}));

export const DepartureBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  color: theme.palette.textPrimary,

  "& > span.airport": {
    fontSize: 13,
    lineHeight: "10px",
  },

  "& > span.time": {
    fontSize: 18,
  },

  "& > span.date": {
    fontSize: 11,
    lineHeight: "10px",
  },
}));

export const DurationBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,
  gap: 5,

  "& > div.duration-time": {
    color: theme.palette.textSecondary,
    fontSize: 11,
    textAlign: "center",
  },

  "& > div.flight-line": {
    ...theme.mixins.flexAlignCenter,
    borderRadius: 2.5,
    height: 5,

    "& > div": {
      backgroundColor: theme.palette.borderLight,
      borderRadius: 2,
      margin: "0 1px",

      "&:hover": {
        backgroundColor: theme.palette.primaryLight,
        cursor: "default",
      },
    }
  },

  "& > div.segments": {
    fontSize: 10,
    fontWeight: 600,
    color: theme.palette.textMuted,
    textAlign: "center",
  },
}));

export const ArrivalBlock = styled(DepartureBlock)(({ theme }) => ({
  textAlign: "right",
}));

export const DetailsAndRulesBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "relative",
  height: 33,
  paddingTop: 10,
  paddingBottom: 5,
}));

export const DetailsButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  border: "none",
  backgroundColor: "transparent",
  color: theme.palette.primaryLight,
  fontSize: 13,
  lineHeight: 1,
  cursor: "pointer",

  "& > span": {
    fontSize: 11,
    lineHeight: 1,
  },

  "& > span.active": {
    transform: "rotate(90deg)",
  },
}));

export const RulesButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  right: 10,
  bottom: 5,
  fontSize: 10,
  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",

  "& > span": {
    fontSize: 10,
    lineHeight: 1,
  },

  "& > span.active": {
    transform: "rotate(90deg)",
  },
}));

export const FlightDetails = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  padding: 10,
}));

export const FlightSegment = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: 25,
  backgroundColor: theme.palette.primarySubtle,
  boxShadow: `0 2px 4px 0 ${theme.palette.shadowMd}`,
  padding: 10,
  color: theme.palette.textPrimary,
  fontSize: 12,

  [theme.down("sm")]: {
    flexWrap: "wrap",
  },

  "& > .flightInfo": {
    flexGrow: 1,

    [theme.down("sm")]: {
      order: 3,
      width: "100%",
    },
  },

  "& > .baggageCabinInfo": {
    textTransform: "capitalize",
    minWidth: 80,
    textAlign: "center",

    [theme.down("sm")]: {
      order: 2,
    },
  },
}));

export const FlightSegmentTimeAircraft = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 10,

  "& > .flightAndDuration": {
    ...theme.mixins.flexAlignCenter,
    gap: 10,

    "& > .duration": {
      fontSize: 10,
    },
  },
}));

export const FlightSegmentTimings = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 20,
  width: "100%",

  "& > .flightTime": {
    color: theme.palette.textPrimary,
    fontSize: 14,

    "& > span": {
      color: theme.palette.textMuted,
      fontSize: 12,
      paddingLeft: 5,
    },
  },

  "& > .flightPlace": {
    display: "flex",
    gap: 10,

    "& > .flightPlaceCode": {
      fontSize: 12,
      color: theme.palette.textPrimary,
      textTransform: "uppercase",
    },

    "& > .flightPlaceName": {
      ...theme.mixins.flexColumn,

      "& > span": {
        color: theme.palette.textMuted,
        fontSize: 12,
        lineHeight: "20px",
      },
    },
  },
}));

export const FlightSegmentIcons = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 3,
  paddingTop: 5,
  fontSize: 20,
  lineHeight: 1,
  color: theme.palette.primaryDark,

  "& .hasNotBaggage": {
    color: theme.palette.errorDark,
  },
}));

export const TransferBlock = styled("div")(({ theme }) => ({

}));

export const TransferTime = styled("div")(({ theme }) => ({
  color: theme.palette.primaryLight,
  fontSize: 14,
}));

export const CharterBadge = styled("div")(({ theme }) => ({
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: 4,
  fontSize: 11,
  fontWeight: 500,
  background: theme.palette.successBg,
  border: `1px solid ${theme.palette.successBorder}`,
  color: theme.palette.successDark,
}));
